<template>
  <div class="section">
    <h3 class="section-title">{{ account.id > -1 ? `${account.name} szerkesztése` : 'Új fiók' }}</h3>
    <div class="section-content">
      <b-alert
        variant="success"
        :show="message.length > 0"
      >
        {{ message }}
      </b-alert>
      <b-form-group
        :state="nameState && errors$name.length < 1"
        :invalid-feedback="errors$name"
      >
        <label for="name">Név</label>
        <b-form-input
          id="name"
          v-model="name"
          :state="nameState && errors$name.length < 1"
          type="text"
          placeholder="A fiók neve"
          required
        />
      </b-form-group>
      <b-form-group
        :state="errors$lang.length < 1"
        :invalid-feedback="errors$lang"
      >
        <label for="name">Nyelv</label>
        <b-form-select
          v-model="lang"
          :state="errors$lang.length < 1"
          :options="langs"
        />
      </b-form-group>
      <b-form-group
        :state="errors$db_size.length < 1"
        :invalid-feedback="errors$db_size"
      >
        <label for="db_size">Adatbázis mérete</label>
        <b-form-input
          id="db_size"
          v-model="db_size"
          :state="dbSizeState && errors$db_size.length < 1"
          type="number"
          min="0"
          max="99999999"
          placeholder="Add meg az adatbázis méretét"
        />
      </b-form-group>
      <b-form-group
        :state="errors$brands.length < 1"
        :invalid-feedback="errors$brands"
      >
        <label for="brands">Brandek</label>
        <tags-input
          v-model="brand"
          :tags="tags"
          placeholder="Írj be egy brandet"
          @tags-changed="tagsChanged"
        />
      </b-form-group>
      <b-form-group
        :state="errors$seasons.length < 1"
        :invalid-feedback="errors$seasons"
      >
        <label for="brands">Szezonok</label>
        <tags-input
          v-model="season"
          :tags="seasonTags"
          :autocomplete-items="seasonSelection"
          :add-only-from-autocomplete="true"
          :autocomplete-min-length="0"
          placeholder="Válassz egy szezont"
          @tags-changed="seasonsChanged"
        />
      </b-form-group>
      <b-form-group
        :state="industryState && errors$industry_id.length < 1"
        :invalid-feedback="errors$industry_id"
      >
        <label for="name">Iparág</label>
        <b-form-select
          v-model="industry_id"
          :state="industryState && errors$industry_id.length < 1"
          :options="industrySelection"
        />
      </b-form-group>
      <b-form-group
        :state="espState && errors$esp_id.length < 1"
        :invalid-feedback="errors$esp_id"
      >
        <label for="name">Szolgáltató</label>
        <b-form-select
          v-model="esp_id"
          :state="espState && errors$esp_id.length < 1"
          :options="espSelection"
        />
      </b-form-group>
      <customer-select
        :customer-state="customerState && errors$customer_id.length < 1"
        :customer-id.sync="customer_id"
        :customer-error.sync="errors$customer_id"
      />
      <rule-blocking
        v-model="blocked_rules"
        @add-rule="addBlockedRule"
        @remove-rule="removeBlockedRule"
      ></rule-blocking>
      <div class="section-divider" />
      <b-form-group
        class="text-right"
      >
        <div class="row">
          <div class="col-6 text-left">
            <b-button
              :href="$url('accounts.index')"
            >
              <span>Vissza</span>
            </b-button>
          </div>
          <div class="col-6">
            <b-button
              :disabled="saving || !validAccount"
              variant="success"
              @click="save"
            >
              <span>Mentés</span>
              <b-spinner
                v-show="saving"
                variant="light"
                label="Mentés"
                small
              />
            </b-button>
          </div>
        </div>
      </b-form-group>
    </div>
  </div>
</template>
<script>
import VueTagsInput from '@johmun/vue-tags-input'
import CustomerSelect from '../customer/CustomerSelect'

import FormValidation from '../../utils/mixins/FormValidation'
import ErrorHandler from '../../utils/mixins/ErrorHandler'

import RuleBlocking from './RuleBlocking'

export default {
  components: {
    'tags-input': VueTagsInput,
    'customer-select': CustomerSelect,
    'rule-blocking': RuleBlocking
  },
  mixins: [
    FormValidation(['name', 'brands', 'customer_id', 'industry_id', 'seasons', 'lang', 'esp_id', 'db_size']),
    ErrorHandler()
  ],
  props: {
    account: {
      type: Object,
      default: () => ({
        id: -1,
        name: '',
        brands: [],
        industry: null,
        customer_id: -1,
        lang: 'hu',
        esp_id: -1,
        industry_id: -1,
        seasons: [],
        db_size: 0,
        blocked_rules: []
      })
    },
    seasonOptions: {
      type: Array,
      required: true
    },
    industryOptions: {
      type: Array,
      required: true
    },
    espOptions: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      id: -1,
      name: '',
      brands: [],
      blocked_rules: [],
      lang: 'hu',
      db_size: 0,
      langs: [
        {text: 'Magyar', value: 'hu'},
        {text: 'Angol', value: 'en'},
      ],
      esp_id: -1,
      industry_id: -1,
      seasons: [],
      customer_id: -1,
      brand: '',
      season: '',
      saving: false,
      message: ''
    }
  },
  computed: {
    industrySelection: function() {
      var selection = [{
        text: 'Válassz egy iparágat',
        value: -1
      }]

      _.forEach(this.industryOptions, industry => {
        selection.push({text: industry.slug, value: industry.id})
      })

      return selection
    },
    espSelection: function() {
      var selection = [{
        text: 'Válassz egy szolgáltatót',
        value: -1
      }]

      _.forEach(this.espOptions, esp => {
        selection.push({text: esp.slug, value: esp.id})
      })

      return selection
    },
    seasonSelection: function() {
      var selection = []

      _.forEach(this.seasonOptions, season => {
        selection.push({text: season.slug, id: season.id})
      })

      return selection
    },
    seasonTags: function() {
      return _.map(this.seasons, season => ({text: season.slug, id: season.id, classes: "bg-success"}))
    },
    tags: function () {
      return _.map(this.brands, brand => ({text: brand, classes: "bg-primary"}))
    },
    nameState: function() {
      return this.name.length > 0
    },
    industryState: function() {
      return this.industry_id !== -1
    },
    espState: function() {
      return this.esp_id !== -1
    },
    customerState: function() {
      return this.customer_id !== -1
    },
    dbSizeState: function() {
      return this.db_size > 0 && this.db_size < 100000000
    },
    validAccount: function() {
      return this.nameState && this.industryState && this.customerState && this.espState && this.dbSizeState
    }
  },
  mounted() {
    _.forEach(this.account, (value, name) => {
      if(value !== null) {
        this[name] = value
      }
    })
  },
  methods: {
    addBlockedRule(id) {
      var found = _.find(this.blocked_rules, rule => rule.id === id)
      if(typeof found === 'undefined') {
        this.blocked_rules.push({id})
      }
    },
    removeBlockedRule(id) {
      var found = _.findIndex(this.blocked_rules, rule => rule.id === id)
      if(found !== -1) {
        this.blocked_rules.splice(found, 1)
      }
    },
    tagsChanged(tags) {
      this.brands = _.map(tags, tag => tag.text)
    },
    seasonsChanged(seasons) {
      this.seasons = _.map(seasons, season => ({slug: season.text, id: season.id}))
    },
    save() {
      if(!this.validAccount) {
        return
      }

      this.saving = true
      this.clearErrors()

      const path = this.id > -1 ? this.$url('api.accounts.update', this.id) : this.$url('api.accounts.store')
      const method = this.id > -1 ? 'patch' : 'post'

      this.$http[method](path, {
        id: this.id,
        name: this.name,
        customer_id: this.customer_id,
        industry_id: this.industry_id,
        brands: this.brands,
        seasons: this.seasons,
        lang: this.lang,
        esp_id: this.esp_id,
        db_size: this.db_size,
        blocked_rules: this.blocked_rules
      })
        .then(({data}) => {
          if(data.account) {
            this.name = data.account.name
            this.id = data.account.id

            window.location = this.$url('accounts.index')

            this.message = 'Sikeres mentés'
          } else {
            this.handleError('Hiba történt a mentés közben')
          }
        })
        .catch(this.handleErrors)
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>